(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["figgi-compact-consent"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.documentElement;
    const copy = document.getElementById('FiggiCompactConsentCopy');
    if (!copy) return;
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-figgi-cookie-settings]');
      if (!link || !window.privacyBanner?.showPreferences) return;
      event.preventDefault();
      window.privacyBanner.showPreferences().catch(() => {
        window.location.assign(link.href);
      });
    });
    let currentBanner;
    let sizeObserver;
    let stateObserver;

    function measure() {
      const height = currentBanner?.isConnected ? currentBanner.getBoundingClientRect().height : 0;
      root.style.setProperty('--figgi-consent-height', `${Math.ceil(height)}px`);
      root.classList.toggle('figgi-consent-visible', height > 0);
    }

    function enhance() {
      const banner = document.getElementById('shopify-pc__banner');
      if (!banner) {
        sizeObserver?.disconnect();
        stateObserver?.disconnect();
        currentBanner = null;
        measure();
        return;
      }
      if (banner === currentBanner) return;
      const body = banner.querySelector('.shopify-pc__banner__body');
      const heading = body?.querySelector('h2');
      const buttons = banner.querySelector('.shopify-pc__banner__btns');
      const accept = banner.querySelector('#shopify-pc__banner__btn-accept');
      const decline = banner.querySelector('#shopify-pc__banner__btn-decline');
      const preferences = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
      if (!body || !heading || !buttons || !accept || !decline || !preferences) return;

      sizeObserver?.disconnect();
      stateObserver?.disconnect();
      if (!banner.classList.contains('figgi-consent-compact')) {
        const details = copy.content.querySelector('details').cloneNode(true);
        const fullCopy = details.querySelector('.figgi-consent-full-copy');
        Array.from(body.childNodes).forEach(node => {
          if (node !== heading) fullCopy.append(node);
        });
        body.append(details);
        const label = preferences.querySelector('span');
        if (label) label.textContent = copy.content.querySelector('[data-figgi-preferences-label]').textContent;
        buttons.append(accept, decline, preferences);
        banner.classList.add('figgi-consent-compact');
      }
      currentBanner = banner;
      sizeObserver = new ResizeObserver(measure);
      sizeObserver.observe(banner);
      stateObserver = new MutationObserver(measure);
      stateObserver.observe(banner, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
      measure();
    }

    enhance();
    new MutationObserver(enhance).observe(document.body, { childList: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
